import React, { useState } from 'react';
import './../../styles/styles.css'; // Import your CSS file for styling

export default function Tooltip({ text, children }) {
    const [showTooltip, setShowTooltip] = useState(false);

    const handleMouseEnter = () => {
        setShowTooltip(true);
    };

    const handleMouseLeave = () => {
        setShowTooltip(false);
    };

    return (
        <div className="tooltip-container" onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
            {children}
            {showTooltip && <div className="tooltip">{text} <div class="arrow-down"></div></div>}
        </div>
    );
};